import Vue from "vue";
import 'vant/lib/index.css';

import {
    NumberKeyboard,
    Popup,
    Toast,
    Image,
    Icon, Form, Field, Cascader
} from 'vant';

Vue.prototype.$toast = Toast;

Vue.use(NumberKeyboard)
    .use(Popup)
    .use(Image)
    .use(Icon)
    .use(Form)
    .use(Field)
    .use(Cascader)


